import { Component } from '@angular/core';

@Component({
  selector: 'kbxl-admin-header',
  templateUrl: './admin-header.component.html',
  styleUrls: ['./admin-header.component.scss'],
})
export class AdminHeaderComponent {}
